/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useRef, useState, useCallback } from 'react';
//import './ChatBox.css';
import './ChatBoxDefault.css';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getPublicPageTimezone } from '@/common/utils/timezoneUtils';
import LoadingPanel from '@/component/common/LoadingPanel';
import {
    buildListCategoriesMessage,
    buildListItemMessage,
    buildListTagFieldMessage,
    buildListTicketMessage,
    buildQueryForTagFieldWithSelectedItem,
    checkMessageOutOfSession,
    buildFreeMessage,
    buildTheEndMessage,
    postMessage,
    createMessageList,
    sortListPreviousMessage,
    prepareDataForChatBotV2,
    buildLoadTagFiledMessage,
    buildQAFormMessage,
    getFormSystemQA,
    buildQAFormLiveChat,
    getCurrentTimeForMessage,
    anounymousEndLiveChat,
    onSubscriptionUpdateMessage,
    onSubscriptionDeleteMessage,
    buildMessageSuggestUsingAI,
    buildLoadingDrilldownMessage,
} from './handler/ChatBoxHandler';
import { fetchDrilldownStats, fetchFieldItems, fetchRemainingFields, decideNextStep, enrichFieldsWithPriority } from './service/chatBotDataService';
import { useRecoilState } from 'recoil';
import { showChatBoxAtom } from '@/state/atom/showChatBoxAtom';
import Storage from '@/amplify/storage';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { cloneDeep } from 'lodash';
import CollapseChatBox from './elements/CollapseChatBox';
import ExpandHeaderChatbox from './elements/ExpandHeaderChatbox';
import {
    updatePreviewCategoryListAtom,
    updatePreviewSettingAtom
} from '@/state/atom/chatBotPreview';
import ChatBotInput from './elements/ChatBotInput';
import ChatBotLiveChat from './elements/ChatBotLiveChat';
import ChatBotListMessage from './elements/ChatBotListMessage';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { v4 as uuidv4 } from 'uuid';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { resolveMessages, getMessageFromResolved } from '@/service/messageResolverService';
import { LOCALE_KEY_MAPPING } from '@/common/constant/ChatBotMessageConfig';
import {
    onSubscriptionAnonymousChatThread,
    onSubscriptionAnonymousChatThreadUpdatedMessage
} from './handler/SubscriptionHandler';
import MessageConnecting from './MessageConnecting';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { sendAiChatBotApi } from '@/service/chatAIService';
import { createKibanaInteractChatAI } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import IPRestrictionMessage from '@/component/publicPages/publicKnowledge/IPRestrictionMessage';
import trI18n from '@/common/utils/trI18n';
// import './knowledge-robo-default-style.css';

function ChatBox(props) {
    const { isModePreview, isIframeChatBot, API, deviceWidth, isPublicAccess } = props;
    const POPUlAR_MOBILE_DEVICE_WIDTH = 1024
    const supportThreadType = isIframeChatBot ? Constant.CHAT_BOT_ORIGIN.GEN_SCRIPT : '';
    const [listTagFieldOfSelectedCategory, setListTagFieldOfSelectedCategory] = useState([]);
    const [listTagFieldSelected, setListTagFieldSelected] = useState([]);
    const [listTagItemSelected, setListTagItemSelected] = useState([]);

    const [isEnableBtnSend, setIsEnableBtnSend] = useState(true);
    const [isEnableMsgInput, setIsEnableMsgInput] = useState(true);
    const [messages, setMessages] = useState([]);
    const [idOfResponseMessage, setIdOfResponseMessage] = useState('');
    const [isMaximizedPanel, setIsMaximizedPanel] = useState(false);
    const [filterPublicKnowledge, setFilterPublicKnowledge] = useState({
        viewId: '',
        tagFieldSelected: []
    });

    const [queryGetListKnowledgeBase, setQueryGetListKnowledgeBase] = useState({
        view: '',
        tagFieldSelected: []
    })

    const [listCategories, setListCategories] = useState([]);
    const [selectedOfOptions, setSelectedOptions] = useState({});
    const [listTagFieldId, setListTagFieldId] = useState([]);
    const [listKnowledgeTicketId, setListKnowledgeTicketId] = useState([]);
    const [listTicketIdBeforeFilterTagField, setListTicketIdBeforeFilterTagField] = useState([]);
    const [isShowChatBox, setIsShowChatBox] = useRecoilState(showChatBoxAtom);
    const [chatbotSettings, setChatBotSettings] = useState({});
    const messageRef = useRef();
    const [listOptionsAutocomplete, setListOptionsAutocomplete] = useState([]);
    const [supportThreadIdState, setSupportThreadId] = useState(
        localStorageUtil.getAnonymousSupportId(supportThreadType)
    );
    const [affiliationOrganization, setAffiliationOrganization] = useState('');
    const [affiliationProject, setAffiliationProject] = useState('');
    const [listSelectedItemOfSession, setListSelectedItemOfSession] = useState([]);
    const [previewSetting, setPreviewSetting] = useRecoilState(updatePreviewSettingAtom);
    const [previewCategoryList, setPreviewCategoryList] = useRecoilState(
        updatePreviewCategoryListAtom
    );
    const [maxNumberAnswer, setMaxNumberAnswer] = useState(1);
    const [useImageInAnswer, setUseImageAnswer] = useState(false);
    const [numberHitKnowledgeTicket, setNumberHitKnowledgeTicket] = useState(0);
    const [freeMessage, setFreeMessage] = useState('');
    const [projectAlias, setProjectAlias] = useState();
    const [categoryIdSelected, setCategoryIdSelected] = useState('');
    const [formQASystem, setFormQASystem] = useState({});
    const [isShowModalReload, setIsShowModalReload] = useState(false);
    const [actionWhenNotResolve, setActionWhenResolve] = useState(3);
    const [isActivateLiveChat, setIsActivateLiveChat] = useState(false);
    const [supportTicketId, setSupportTicketId] = useState(false);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [isShowModalEndChat, setIsShowModalEndChat] = useState(false);
    const [isShowMsgConnecting, setIsShowMsgConnecting] = useState(true);
    const [sentMessageList, setSentMessageList] = useState([]);
    const [listAgentData, setListAgentData] = useState([]);
    const [updatedMessage, setUpdatedMessage] = useState({});
    const [deletedMessage, setDeletedMessages] = useState({});
    const [isNewUnReadMessage, setIsNewUnReaMessage] = useState(false);
    const [projectInuseDetail,setProjectInuseDetail] = useState({});

    const [currentCorporationDetail,setCurrentCorporationDetail] = useState({});
    const [corporationDetail,setCorporationDetail] = useRecoilState(corporationAtom);
    const [isLoadingCss, setIsLoadingCss] = useState(false);
    const [enableListTicket,setEnableListTicket] = useState(false);
    const [listTagFieldSkip,setListTagFieldSkip] = useState([]);
    const [resolvedMessages, setResolvedMessages] = useState({});
    const [isLoadingStep, setIsLoadingStep] = useState(false);

    // Helper function to get message with variable substitution
    // MUST be at top level, before any conditional returns
    // Supports both locale keys (USER11MSG001) and message keys (bot_thank_you_message)
    const getMessage = useCallback((messageKey, variables = {}) => {
        // Check if this is a locale key that needs mapping
        const actualKey = LOCALE_KEY_MAPPING[messageKey] || messageKey;
        return getMessageFromResolved(resolvedMessages, actualKey, variables);
    }, [resolvedMessages]);

    const renderDefaultMessage = (listCategoriesOfProject, chatbotSetting, formQASystems = {}) => {
        let newMessage;
        if (listCategoriesOfProject?.length > 0) {
            newMessage = buildListCategoriesMessage(listCategoriesOfProject);
            // do not save first message when user the has not started the cha
            newMessage.isNotSaved = true;
        } else {
            if (!Utils.isEmptyObject(newMessage)) {
                return setMessages(prev => [...prev, newMessage]);
            }

            switch (chatbotSetting?.actionWhenNotResolve) {
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                    .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                    let dataLiveChat = {
                        isDefault: true,
                        formQASystem: formQASystems
                    };
                    newMessage = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                    let data = {
                        isDefault: true,
                        data: {
                            formQASystem: formQASystems
                        }
                    };
                    newMessage = buildQAFormMessage(data, resolvedMessages, 'CBOTMSG011');
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                default:
                    if (!Utils.isEmptyString(chatbotSetting.freeMsg)) {
                        const freeMessageContent = getRichTextFieldContent(chatbotSetting.freeMsg);
                        if (freeMessageContent) {
                            newMessage = buildFreeMessage(chatbotSetting.freeMsg);
                        }
                    }
                    break;
            }
        }
        if (!Utils.isEmptyArray(newMessage)) {
            setMessages(prev => [...prev, newMessage]);
        }
    };

    const renderDefaultMessagePreview = async (
        listCategoriesOfProject,
        chatbotSetting,
        formQASystems = {}
    ) => {
        let newMessage;
        if (listCategoriesOfProject?.length > 0) {
            newMessage = buildListCategoriesMessage(listCategoriesOfProject);
            // do not save first message when user the has not started the cha
            newMessage.isNotSaved = true;
            setMessages([newMessage]);
        } else {
            if (Utils.isEmptyObject(formQASystem)) {
                let formSystemQA = await getFormSystemQA(props.subDomain);
                setFormQASystem(formSystemQA);
            }
            switch (chatbotSetting?.actionWhenNotResolve) {
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                    .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                    let dataLiveChat = {
                        isDefault: true,
                        formQASystem: formQASystems
                    };
                    newMessage = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                    setMessages([newMessage]);
                    break;

                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                    let data = {
                        isDefault: true,
                        data: {
                            formQASystem: formQASystems
                        }
                    };
                    newMessage = buildQAFormMessage(data, resolvedMessages, 'CBOTMSG011');
                    setMessages([newMessage]);
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                default:
                    if (!Utils.isEmptyString(chatbotSetting.freeMsg)) {
                        const freeMessageContent = getRichTextFieldContent(chatbotSetting.freeMsg);
                        if (freeMessageContent) {
                            newMessage = buildFreeMessage(chatbotSetting.freeMsg);
                            setMessages([newMessage]);
                        }
                    }
                    break;
            }
        }
    };

    const renderPreviousMessage = (
        listPreviousMessage,
        listCategoriesOfProject,
        chatbotSetting
    ) => {
        let contentMessageList = sortListPreviousMessage(listPreviousMessage, resolvedMessages);
        const lastMessage = contentMessageList[contentMessageList.length - 1];

        if (lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE) {
            let newMessage;

            if (listCategoriesOfProject.length > 0) {
                newMessage = buildListCategoriesMessage(listCategoriesOfProject);
                contentMessageList.push(newMessage);
            }
        }

        if (lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY) {
            let idOfCategory = lastMessage.idOfOption;

            const categoryDetail = listCategoriesOfProject?.find(category => {
                return category.id === idOfCategory;
            });

            if (Utils.isEmptyObject(categoryDetail)) {
                switch (chatbotSetting?.actionWhenNotResolve) {
                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                        .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                        let idQALiveChat = `qaform_${uuidv4()}`;
                        let dataLiveChat = {
                            isDefault: true,
                            formQASystem: formQASystem,
                            idQA: idQALiveChat
                        };
                        let newFreeMessageQALiveChat = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                        contentMessageList.push(newFreeMessageQALiveChat);
                        break;

                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                        let idQA = `qaform_${uuidv4()}`;
                        let data = {
                            isDefault: true,
                            data: {
                                formQASystem: formQASystem
                            },
                            idQA: idQA
                        };
                        let newFreeMessageQA = buildQAFormMessage(data, resolvedMessages, 'CBOTMSG011');
                        contentMessageList.push(newFreeMessageQA);
                        break;

                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                    default:
                        let newFreeMessage = buildFreeMessage(chatbotSetting.freeMsg, 1);
                        contentMessageList.push(newFreeMessage);
                        if (listCategoriesOfProject.length > 0) {
                            const theEndMessage = buildTheEndMessage(2, formQASystem, resolvedMessages);
                            contentMessageList.push(theEndMessage);
                        }
                        break;
                }
            } else {
                const messageListTagFiled = buildLoadTagFiledMessage(idOfCategory, formQASystem, 1, usingAI, listTagFieldSelected, listTagItemSelected);

                contentMessageList.push(messageListTagFiled);
            }
        }

        if (lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT) {
            const theEndMessage = buildTheEndMessage(1, formQASystem, resolvedMessages);
            postMessage(theEndMessage, supportTicketId, affiliationOrganization);
            contentMessageList.push(theEndMessage);
        }

        setMessages([...contentMessageList]);
    };

    const getCurrentStateOfSession = (listMessagePrevious,listCategoriesOfProject,corporationId,projectId) => {
        let contentMessageList = sortListPreviousMessage(listMessagePrevious, resolvedMessages);
        contentMessageList = contentMessageList.reverse()
        let latestSelectCategoryIndex = -1
        for (let index = 0; index < contentMessageList.length; index++) {
            const message = contentMessageList[index];
            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY){
                latestSelectCategoryIndex = index
                break;
            }
            
        }

        let listMessageOfLastSession = contentMessageList.slice(0,latestSelectCategoryIndex+1)
        let idOfSelectedCategory = '';
        let listItemSelectedInSession = [];
        let listTagFieldSelectedInSession = [];
        let filterInfo = []
        let isEndSession = false;
        let listTagFiledIdOfSelectItem = [];
        for (let index = 0; index < listMessageOfLastSession.length; index++) {
            const message = listMessageOfLastSession[index];

            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY){
                idOfSelectedCategory = message.idOfOption
            };

            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_FIELD){
                if(!Utils.isEmptyArray(message.listTagItemSelected)){
                    listItemSelectedInSession = [...listItemSelectedInSession,...message.listTagItemSelected]
                };

                if(!Utils.isEmptyArray(message.listTagFieldSelected)){
                    listTagFieldSelectedInSession = [...listTagFieldSelectedInSession,...message.listTagFieldSelected]
                };

                listTagFieldSelectedInSession.push(message.idOfOption);
            }

            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM){
                if(!Utils.isEmptyArray(message.listTagItemSelected)){
                    listItemSelectedInSession = [...listItemSelectedInSession,...message.listTagItemSelected]
                };

                if(!Utils.isEmptyArray(message.listTagFieldSelected)){
                    listTagFieldSelectedInSession = [...listTagFieldSelectedInSession,...message.listTagFieldSelected]
                };

                listItemSelectedInSession.push(message.idOfOption);
                listTagFiledIdOfSelectItem.push(message.idOfTagField)
                filterInfo.push({
                    idTagField: message.idOfTagField,
                    idTagItem: message.idOfOption
                });
            }

            if([Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.THE_END,Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE].includes(message.messageType)){
                isEndSession = true
            }
            
        }

        if(!isEndSession && idOfSelectedCategory){
            listItemSelectedInSession = Utils.filterDuplicates(listItemSelectedInSession)
            listTagFieldSelectedInSession = Utils.filterDuplicates(listTagFieldSelectedInSession)
            setListTagFieldSelected([...listTagFieldSelectedInSession]);
            let listSkipTagField = listTagFieldSelectedInSession?.filter(id => !listTagFiledIdOfSelectItem.includes(id));
            setListTagFieldSkip([...listSkipTagField])
            setListTagItemSelected([...listItemSelectedInSession]);
            let tagFieldSelected = []
            filterInfo?.forEach(info => {
                let query = buildQueryForTagFieldWithSelectedItem(info.idTagField, info.idTagItem);
                let newFilter = {
                    bool: {
                        should: query
                    }
                };
                tagFieldSelected.push(newFilter);
            });

            const categorySelected = listCategoriesOfProject?.find(category => category.id === idOfSelectedCategory)
            const viewId = categorySelected?.chatBotCategorySetting?.viewId;
            setFilterPublicKnowledge({ viewId: viewId,
                tagFieldSelected: tagFieldSelected
             });
            setQueryGetListKnowledgeBase({ view: viewId,
                tagFieldSelected: tagFieldSelected
             });
             setCategoryIdSelected(idOfSelectedCategory)
             setIsLoadingStep(true);
             fetchDrilldownStats({
                 projectId,
                 subDomain: props?.subDomain,
                 structure: categorySelected.viewStructure,
                 corporationId,
                 viewId: categorySelected?.chatBotCategorySetting?.viewId
             }).then(response => {
                 let tagFiledList = [];
                 const listTagFiledId = categorySelected.listTagFiledId;
                 let settingTagFiledOfCategory = categorySelected?.chatBotCategorySetting?.tagFields;
                 response?.tagFieldList?.forEach(tagField => {
                     if (listTagFiledId.includes(tagField.id)) {
                         const settingTagFiled = settingTagFiledOfCategory.find(setting => setting.id === tagField.id);
                         if (!Utils.isEmptyObject(settingTagFiled)) {
                             tagField.priority = settingTagFiled?.priority;
                             tagField.order = settingTagFiled.order;
                             tagFiledList.push(tagField);
                         }
                     }
                 });
                 tagFiledList = Utils.sortListTagFieldOfCategory(cloneDeep(tagFiledList));
                 setListTagFieldOfSelectedCategory(tagFiledList);
             }).catch(() => {
                 // API failed during session restore — drilldown data unavailable
                 // User can still interact; handlers will fallback via handlerWhenSelectedFormNoFound
             }).finally(() => {
                 setIsLoadingStep(false);
             });
        }
    }

    const handlerWhenSelectedFormNoFound = (messageClone, newMessagesListParams) => {
        let settings = isModePreview ? previewSetting : chatbotSettings;

        switch (settings?.actionWhenNotResolve) {
            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                let idQALiveChat = `qaform_${uuidv4()}`;
                let dataLiveChat = {
                    isDefault: true,
                    formQASystem: formQASystem,
                    categoryIdSelected: categoryIdSelected,
                    idQA: idQALiveChat
                };
                let newFreeMessageQALiveChat = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                postMessage(
                    newFreeMessageQALiveChat,
                    supportThreadIdState,
                    affiliationOrganization,
                    false,
                    isModePreview,
                    idQALiveChat
                );
                setMessages(pev => [...pev, newFreeMessageQALiveChat]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                let idQA = `qaform_${uuidv4()}`;
                let data = {
                    isDefault: false,
                    idQA: idQA,
                    data: {
                        categoryIdSelected: categoryIdSelected,
                        formQASystem: formQASystem
                    }
                };
                const newMessage = buildQAFormMessage(data, resolvedMessages);
                postMessage(
                    newMessage,
                    supportThreadIdState,
                    affiliationOrganization,
                    false,
                    isModePreview,
                    idQA
                );
                setMessages(pev => [...pev, newMessage]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
            default:
                let newMessagesList = !Utils.isEmptyArray(newMessagesListParams)
                    ? newMessagesListParams
                    : [];
                newMessagesList.push(buildFreeMessage(freeMessage, newMessagesList.length));

                if (!Utils.isEmptyArray(listCategories)) {
                    newMessagesList.push(buildTheEndMessage(newMessagesList.length, formQASystem, resolvedMessages));
                }
                createMessageList(
                    newMessagesList,
                    supportThreadIdState,
                    affiliationOrganization,
                    isModePreview
                );
                setMessages([...messageClone, ...newMessagesList]);
                break;
        }
        return;
    };

    useEffect(() => {
        if (!isModePreview) {
            setProjectAlias(props.projectId);
            prepareDataForChatBotV2(
                props.projectId,
                props.subDomain,
                isModePreview,
                supportThreadType
            ).then(async response => {
                
                let affiliationOrganizationDetail = response.affiliationOrganizationDetail;
                affiliationOrganizationDetail.name = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,affiliationOrganizationDetail?.name)
                setCurrentCorporationDetail(affiliationOrganizationDetail);
                
                let affiliationProjectDetail = response.affiliationProjectDetail;
                affiliationProjectDetail.name = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,affiliationProjectDetail?.name)
                setProjectInuseDetail(affiliationProjectDetail);

                let {
                    chatbotSetting,
                    isCreateNewSupportThread,
                    newThreadSupport,
                    projectId,
                    corporationId
                } = response;
                let listCategoriesOfProject = Utils.isEmptyArray(response?.listCategoriesProject)
                    ? []
                    : response?.listCategoriesProject;
                let formQASystems = Utils.isEmptyObject(response?.formQASystem)
                    ? {}
                    : response?.formQASystem;
                listCategoriesOfProject = Utils.sortCategoriesByOrder(
                    cloneDeep(listCategoriesOfProject)
                );

                setSupportTicketId(response.ticketId);

                setIsActivateLiveChat(
                    !Utils.isEmptyString(response.ticketId) &&
                        response.ticketId.includes(Constant.TICKET_PREFIX.REQ)
                );

                if (!Utils.isEmptyArray(response.listAgentData)) {
                    setListAgentData(response.listAgentData);
                }
                let listPreviousMessage = response?.chatPostList;
                listPreviousMessage = listPreviousMessage?.filter(message => {
                    if (
                        [
                            Constant.POST_TYPE.MSG,
                            Constant.POST_TYPE.IMAGE,
                            Constant.POST_TYPE.FILE,
                            Constant.POST_TYPE.MSG_FILES
                        ].includes(message?.postType) &&
                        !message?.deliverInfo?.status && 
                        message.affiliationProject
                    ) {
                        return false;
                    }

                    return message.postType !== Constant.POST_TYPE.ANONYMOUS_END_LIVE_CHAT;
                });
                let enableListTicketSetting = chatbotSetting?.hasOwnProperty('enableListTicket') ? chatbotSetting.enableListTicket : true
                setEnableListTicket(enableListTicketSetting)
                //check setting max num of answer
                if (!chatbotSetting.maxNumberAnswer) {
                    chatbotSetting.maxNumberAnswer = 5;
                }

                if (!Utils.isEmptyObject(chatbotSetting)) {
                    const [logoIcon, headerIcon, sendIcon] = await Promise.all([
                        getLogoHeader(chatbotSetting?.logo),
                        getLogoHeader(chatbotSetting?.headerIcon),
                        getLogoHeader(chatbotSetting?.sendIcon)
                    ]);

                    chatbotSetting.logo = logoIcon
                    chatbotSetting.headerIcon = headerIcon
                    chatbotSetting.sendIcon = sendIcon
                }

                //enable chatbot
                if (chatbotSetting.isActivateChatbot) {
                    props.setIsEnableChatBox(true);
                }

                if (chatbotSetting.numberHitKnowledgeTicket) {
                    setNumberHitKnowledgeTicket(chatbotSetting.numberHitKnowledgeTicket);
                } else {
                    setNumberHitKnowledgeTicket(5);
                }
                setUseImageAnswer(chatbotSetting.useImageInAnswer);
                setFreeMessage(chatbotSetting.freeMsg);
                setAffiliationOrganization(corporationId);
                setAffiliationProject(projectId);
                setListCategories(listCategoriesOfProject);
                setChatBotSettings(chatbotSetting);
                setFormQASystem(formQASystems);
                setActionWhenResolve(chatbotSetting.actionWhenNotResolve);

                // Get message config of knowledge robo
                const currentMessageConfigJson = chatbotSetting.messageConfig;
                let initMessageConfig = '';
                
                if (currentMessageConfigJson && Utils.isValidJSONObject(currentMessageConfigJson)) {
                    // Use message config from S3 if valid
                    initMessageConfig = currentMessageConfigJson;
                }
                // If empty or invalid, resolveMessages will use defaults
                const resolved = resolveMessages(initMessageConfig);
                setResolvedMessages(resolved);

                //set support thread to local storage
                let clientThreadSupport = localStorageUtil.getAnonymousSupportId(supportThreadType);
                if (isCreateNewSupportThread && !Utils.isEmptyString(newThreadSupport)) {
                    clientThreadSupport = Utils.isEmptyObject(
                        localStorageUtil.getAnonymousSupportId(supportThreadType)
                    )
                        ? {}
                        : clientThreadSupport;
                    clientThreadSupport[projectId] = newThreadSupport;
                    setSupportThreadId(newThreadSupport);
                    localStorageUtil.setAnonymousSupportId(clientThreadSupport, supportThreadType);
                } else {
                    setSupportThreadId(clientThreadSupport[projectId]);
                }

                //subscription chat post
                onSubscriptionAnonymousChatThread(clientThreadSupport[projectId], {
                    messages: messages,
                    setMessages: setMessages,
                    setIsActivateLiveChat,
                    listAgentData: Utils.isEmptyArray(response.listAgentData)
                        ? []
                        : response.listAgentData,
                    setListAgentData: setListAgentData,
                    projectId: projectId,
                    corporationId: corporationId,
                    formQASystems: formQASystems,
                    setIsOpenModalReloadPage: setIsShowModalReload,
                    setIsNewUnReaMessage: setIsNewUnReaMessage,
                    resolvedMessages: resolved
                });
                onSubscriptionAnonymousChatThreadUpdatedMessage(clientThreadSupport[projectId], {
                    setUpdatedMessage: setUpdatedMessage
                });

                if (isCreateNewSupportThread || listPreviousMessage.length === 0) {
                    renderDefaultMessage(
                        listCategoriesOfProject,
                        chatbotSetting,
                        formQASystems,
                        newThreadSupport,
                        corporationId
                    );
                } else {
                    renderPreviousMessage(
                        listPreviousMessage,
                        listCategoriesOfProject,
                        chatbotSetting
                    );
                    getCurrentStateOfSession(listPreviousMessage,listCategoriesOfProject,corporationId,projectId)
                }

                let existedKnowledgeRoboCss = document.getElementById('knowledge-robo-css');
                if (!existedKnowledgeRoboCss) {
                    const versionCss = chatbotSetting?.versionKnowledgeRoboStyleCss
                    const keyFile = Utils.genKeyFileCss(corporationId, projectId, versionCss, Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO);
                    const defaultCssLink = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/assets/knowledge-robo-default-style.css`;
                    let linkS3 = ''
                    if (!keyFile) {
                        linkS3 = defaultCssLink;
                    } else {
                        linkS3 = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/${keyFile}`;
                    }
                    const linkElement = document.createElement("link");
                    linkElement.setAttribute("rel", "stylesheet");
                    linkElement.setAttribute("type", "text/css");
                    linkElement.setAttribute("id", "knowledge-robo-css");
                    linkElement.setAttribute(
                        "href",
                        linkS3
                    );
                    linkElement.onerror = () => {
                        linkElement.setAttribute(
                            "href",
                            defaultCssLink
                        );
                    };
                    document.head.appendChild(linkElement);
                    setIsLoadingCss(true)
                }


                if (isIframeChatBot)
                    window.parent.postMessage(Constant.CHATBOT_ACTION.FINISHED_RENDER_CHATBOT, '*');
            });
        }
    }, [props.projectId]);

    useEffect(() => {
        if (!Utils.isEmptyObject(updatedMessage)) {
            const updatedMessageClone = cloneDeep(updatedMessage);
            if (updatedMessageClone.status === 4) {
                onSubscriptionDeleteMessage(messages, setMessages, updatedMessageClone);
            } else {
                onSubscriptionUpdateMessage(messages, setMessages, updatedMessageClone, resolvedMessages);
            }
        }
    }, [updatedMessage]);

    useEffect(() => {
        if (!Utils.isEmptyObject(deletedMessage)) {
            const deletedMessageClone = cloneDeep(deletedMessage);
            onSubscriptionDeleteMessage(messages, setMessages, deletedMessageClone);
        }
    }, [deletedMessage]);

    useEffect(() => {
        if (isModePreview) {
            setAffiliationOrganization(localStorageUtil.getAffiliationOrganization());
            setAffiliationProject(localStorageUtil.getSelectedProjectId());

            if (previewSetting.freeMsg !== freeMessage) {
                setFreeMessage(previewSetting.freeMsg);
            }

            if (previewSetting.numberHitKnowledgeTicket !== numberHitKnowledgeTicket) {
                setNumberHitKnowledgeTicket(previewSetting.numberHitKnowledgeTicket);
            }

            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }

            if (previewSetting.useImageInAnswer !== useImageInAnswer) {
                setUseImageAnswer(previewSetting.useImageInAnswer);
            }

            if (previewSetting.projectAlias !== projectAlias) {
                setProjectAlias(previewSetting.projectAlias);
            }

            if (previewSetting.actionWhenNotResolve !== actionWhenNotResolve) {
                setActionWhenResolve(previewSetting.actionWhenNotResolve);
            }
            
            if(previewSetting.enableListTicket !== enableListTicket){
                setEnableListTicket(previewSetting.enableListTicket)
            }

            // Update messageResolver when messageConfig changes in preview
            if (previewSetting.messageConfig !== undefined) {
                const messageConfigJson = previewSetting.messageConfig || '';
                const resolved = resolveMessages(messageConfigJson);
                setResolvedMessages(resolved);
            }
        }
    }, [previewSetting]);

    useEffect(() => {
        (async () => {
            if (isModePreview) {
                let formSystemQA = await getFormSystemQA(props.subDomain);
                setFormQASystem(formSystemQA);
            }
        })();
    }, [props.subDomain]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted && isModePreview) {
            let newListCategories = Utils.isEmptyArray(previewCategoryList)
                ? []
                : [...previewCategoryList];
            if (newListCategories?.length > 0) {
                newListCategories = Utils.sortCategoriesByOrder(cloneDeep(previewCategoryList));
            }
            setListCategories([...newListCategories]);
        }

        return () => {
            isMounted = false;
        }
    }, [previewCategoryList]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted && isModePreview) {
            clearSession();
            let newListCategories = Utils.isEmptyArray(previewCategoryList)
                ? []
                : [...previewCategoryList];
            if (newListCategories?.length > 0) {
                newListCategories = Utils.sortCategoriesByOrder(cloneDeep(previewCategoryList));
            }
            renderDefaultMessagePreview(newListCategories, previewSetting, formQASystem);
            setIsActivateLiveChat(false);
        }

        return () => {
            isMounted = false;
        }
    }, [
        freeMessage,
        numberHitKnowledgeTicket,
        listCategories,
        maxNumberAnswer,
        useImageInAnswer,
        actionWhenNotResolve,
        formQASystem
    ]);

    const scrollIntoViewMsg = () => {
        setTimeout(() => {
            // if (!isModePreview)  messageRef?.current?.scrollIntoView({ behavior: 'smooth' });
            const element = document.getElementById(`chatbot-msgbox`);
            if (element) {
                let scrollHeight = element?.scrollHeight - element?.clientHeight
                element.scrollTop = scrollHeight;
            }
           
        }, 200);
    };

    const clearSession = () => {
        setMessages([]);
        setListTagFieldSelected([]);
        setListTagItemSelected([]);
        setListKnowledgeTicketId([]);
        setListTicketIdBeforeFilterTagField([]);
        setFilterPublicKnowledge({
            viewId: '',
            tagFieldSelected: []
        });
        setQueryGetListKnowledgeBase({
            viewId: '',
            tagFieldSelected: []
        });
    };

    const scrollIntoViewList = () => {
        setTimeout(() => {
            let idDivContentList = `chatbot-msgbox`;
            const element = document.getElementById(idDivContentList);
            if (element) {
                element.scrollTop = element.scrollHeight;
            }
           
        }, 200);
    };

    useEffect(() => {
        let lastMessage = messages[messages.length - 1];
        switch (lastMessage?.messageType) {
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM:
                setListOptionsAutocomplete(lastMessage?.content);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_FIELD:
                setListOptionsAutocomplete(lastMessage?.content);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_ITEM:
                setListOptionsAutocomplete(lastMessage?.content);
                break;
            default:
                setListOptionsAutocomplete([]);
                break;
        }
        scrollIntoViewMsg();
    }, [messages]);

    useEffect(() => {
        if (!isModePreview) scrollIntoViewList();
    }, [isShowChatBox]);

    //check
    const handleClickFormOption = (selectedOption, idOfMessage) => {
        // validate message
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        setListTagFieldSkip([]);
        setCategoryIdSelected(selectedOption.id);
        //update selected tag field for next session;
        setListTagFieldSelected([]);
        setListTagItemSelected([]);
        setListKnowledgeTicketId([]);
        let { id, name } = selectedOption;
        let messageClone = cloneDeep([...messages]);

        // save first message when user start chat thread;
        let messageListForm = messageClone[messageClone.length - 1];
        if (messageListForm.isNotSaved) {
            postMessage(
                messageListForm,
                supportThreadIdState,
                affiliationOrganization,
                true,
                isModePreview
            );
            messageListForm.isNotSaved = false;
            messageClone[messageClone.length - 1] = messageListForm;
        }

        let newIdMessage = getCurrentTimeForMessage();
        let newMessagesList = [
            {
                content: name,
                isFromMe: true,
                idMessage: newIdMessage,
                idOfOption: id,
                noInFrame: 0,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY,
                listTagFieldSelected: [],
                listTagItemSelected: [],
            }
        ];

        messageClone = [...messageClone, ...newMessagesList];

        //get list tag field used of category
        const categoryDetail = listCategories?.find(category => {
            return category.id === id;
        });

        if (Utils.isEmptyObject(categoryDetail)) {
            handlerWhenSelectedFormNoFound(messageClone, newMessagesList);
            return;
        }

        setFilterPublicKnowledge({
            view: Utils.isEmptyString(categoryDetail?.chatBotCategorySetting?.viewId)
                ? ''
                : categoryDetail.chatBotCategorySetting.viewId,
            tagFieldSelected: []
        });

        setQueryGetListKnowledgeBase({
            view: Utils.isEmptyString(categoryDetail?.chatBotCategorySetting?.viewId)
                ? ''
                : categoryDetail.chatBotCategorySetting.viewId,
            tagFieldSelected: []
        })

        const messageListTagFiled = buildLoadTagFiledMessage(id, formQASystem, 1, usingAI, listTagFieldSelected, listTagItemSelected);
        messageClone.push(messageListTagFiled);

        createMessageList(
            [...newMessagesList],
            supportThreadIdState,
            affiliationOrganization,
            isModePreview,
            selectedOption,
            affiliationProject,
            projectInuseDetail,
            currentCorporationDetail,
            categoryIdSelected
        );
        setMessages([...messageClone]);

        scrollIntoViewMsg();
    };

    //check
    // click tag field
    const handleClickFieldOption = async (selectedOption, idOfMessage) => {
        let { id, name } = selectedOption;
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        if (isLoadingStep) return;

        if (!listTagFieldSelected.includes(id)) {
            setListTagFieldSelected(pev => [...pev, id]);
        }

        let newListTagFieldSelected = [...listTagFieldSelected, id];
        
        const categoryDetail = listCategories?.find(category => {
            return category.id === categoryIdSelected;
        });
        let newIdMessage = getCurrentTimeForMessage();
        let newMessagesList = [
            {
                content: name,
                isFromMe: true,
                idMessage: newIdMessage,
                idOfOption: id,
                noInFrame: 0,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_FIELD,
                categoryName: categoryDetail?.name?.jp?.text,
                listTagFieldSelected: newListTagFieldSelected,
                listTagItemSelected
            }
        ];

        const fieldDetail = listTagFieldOfSelectedCategory?.find(tagField => {
            return tagField.id === id;
        });
        
        if (Utils.isEmptyObject(fieldDetail)) {
            handlerWhenSelectedFormNoFound(messages);
            return;
        }

        // Show user selection + loading immediately
        const loadingMsg = buildLoadingDrilldownMessage();
        setMessages(prev => [...prev, ...newMessagesList, loadingMsg]);

        setIsLoadingStep(true);
        try {
            const result = await fetchFieldItems({
                projectId: affiliationProject,
                subDomain: props.subDomain,
                structure: categoryDetail.viewStructure,
                corporationId: affiliationOrganization,
                targetFieldId: id,
                tagFieldQuery: filterPublicKnowledge.tagFieldSelected || [],
                listTagFieldSelected: newListTagFieldSelected,
                listTagItemSelected
            });

            const responseMsg = buildListItemMessage(id, result.items, newMessagesList.length, name, null, usingAI, [...newListTagFieldSelected], listTagItemSelected);

            // Replace loading with real response
            setMessages(prev => {
                const withoutLoading = prev.filter(m => m.idMessage !== loadingMsg.idMessage);
                return [...withoutLoading, responseMsg];
            });

            // Persist only real messages
            createMessageList(
                [...newMessagesList, responseMsg],
                supportThreadIdState,
                affiliationOrganization,
                isModePreview,
                selectedOption,
                affiliationProject,
                projectInuseDetail,
                currentCorporationDetail,
                categoryIdSelected
            );
        } catch (error) {
            setMessages(prev => prev.filter(m => m.idMessage !== loadingMsg.idMessage));
            handlerWhenSelectedFormNoFound(messages);
        } finally {
            setIsLoadingStep(false);
        }
    };

    //check
    // click tag item
    const handleClickItemOption = async (selectedOfOption, idOfMessage) => {
        
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        if (isLoadingStep) return;

        const categoryDetail = listCategories?.find(category => {
            return category.id === categoryIdSelected;
        });

        let { id, idOfTagField, name } = selectedOfOption;

        const fieldDetail = listTagFieldOfSelectedCategory?.find(tagField => {
            return tagField.id === idOfTagField;
        });

        let newIdMessage = getCurrentTimeForMessage();

        // Build accumulated selectTag: all tags within current category session + current tag, format tagName@fieldName, sorted
        const lastCategoryIdx = [...messages].reverse().findIndex(
            msg => msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY && msg.isFromMe
        );
        const categoryStartIdx = lastCategoryIdx >= 0 ? messages.length - 1 - lastCategoryIdx : 0;
        const scopedMessages = messages.slice(categoryStartIdx);
        const previousTagItems = scopedMessages.filter(
            msg => msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM && msg.isFromMe
        );
        const allSelectTags = [
            ...previousTagItems.map(msg => {
                const tagName = msg.content;
                const fieldName = msg.nameOfTagField;
                return fieldName ? `${tagName}@${fieldName}` : tagName;
            }),
            fieldDetail?.label ? `${name}@${fieldDetail.label}` : name
        ].filter(c => c).sort().join(' ');
        // Build accumulated tagGroup: all tag fields that have a selected tag (incl. current), unique, sorted
        const allTagGroups = [...new Set([
            ...previousTagItems.map(msg => msg?.nameOfTagField),
            fieldDetail?.label
        ].filter(c => c))].sort().join(' ');

        let newMessagesList = [
            {
                content: name,
                isFromMe: true,
                idMessage: newIdMessage,
                idOfOption: id,
                noInFrame: 0,
                idOfTagField: idOfTagField,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM,
                nameCategory: categoryDetail?.name?.jp?.text,
                nameOfTagField: fieldDetail?.label,
                listTagFieldSelected,
                listTagItemSelected,
                accumulatedSelectTag: allSelectTags,
                accumulatedTagGroup: allTagGroups
            }
        ];

        let listSelectedItemOfSessionClone = [...listSelectedItemOfSession, { [idOfTagField]: id }];
        setListSelectedItemOfSession(pev => [...pev, { [idOfTagField]: id }]);

        let filterObjectClone = { ...filterPublicKnowledge };
        let query = buildQueryForTagFieldWithSelectedItem(idOfTagField, id);
        let newFilter = {
            bool: {
                should: query
            }
        };
        
        filterObjectClone.tagFieldSelected.push(newFilter);
        setFilterPublicKnowledge({ ...filterObjectClone });
        setQueryGetListKnowledgeBase({...filterObjectClone});

        if (Utils.isEmptyObject(fieldDetail)) {
            handlerWhenSelectedFormNoFound(newMessagesList);
            return;
        }

        if (!listTagFieldSelected.includes(idOfTagField)) {
            setListTagFieldSelected(prev => [...prev, idOfTagField]);
        }

        if (!listTagItemSelected.includes(id)) {
            setListTagItemSelected(pev => [...pev, id]);
        }

        let newListTagFieldSelected = [...listTagFieldSelected];
        if (!newListTagFieldSelected.includes(idOfTagField)) {
            newListTagFieldSelected = [...newListTagFieldSelected, idOfTagField];
        }
        let newListTagItemSelected = [...listTagItemSelected, id];

        // Show user selection + loading immediately
        const loadingMsg = buildLoadingDrilldownMessage();
        setMessages(prev => [...prev, ...newMessagesList, loadingMsg]);

        setIsLoadingStep(true);
        try {
            const result = await fetchRemainingFields({
                projectId: affiliationProject,
                subDomain: props.subDomain,
                structure: categoryDetail.viewStructure,
                corporationId: affiliationOrganization,
                tagFieldQuery: filterObjectClone.tagFieldSelected,
                listTagFieldSelected: newListTagFieldSelected,
                listTagItemSelected: newListTagItemSelected,
                listTagFieldSkip
            });

            const enrichedFields = enrichFieldsWithPriority(result.remainingFields, listTagFieldOfSelectedCategory);
            const nextStep = decideNextStep({
                totalTicketMatching: result.totalTicketMatching,
                remainingFields: enrichedFields,
                maxHitTicket: numberHitKnowledgeTicket,
                enableListTicket
            });

            let newMessage = {};
            switch (nextStep.type) {
                case Constant.CHATBOT_NEXT_STEP.SHOW_TICKET_LIST:
                    newMessage = enableListTicket ? buildListTicketMessage(
                        filterObjectClone.tagFieldSelected,
                        newMessagesList.length,
                        listSelectedItemOfSessionClone,
                        usingAI
                    ) : buildMessageSuggestUsingAI(newMessagesList.length, resolvedMessages);
                    newMessagesList.push(newMessage);
                    break;
                case Constant.CHATBOT_NEXT_STEP.SHOW_FIELD_PRIORITY: {
                    const priorityField = nextStep.field;
                    setListTagFieldSelected(prev => [...prev, priorityField.id]);
                    const fieldItemsResult = await fetchFieldItems({
                        projectId: affiliationProject,
                        subDomain: props.subDomain,
                        structure: categoryDetail.viewStructure,
                        corporationId: affiliationOrganization,
                        targetFieldId: priorityField.id,
                        tagFieldQuery: filterObjectClone.tagFieldSelected,
                        listTagFieldSelected: [...newListTagFieldSelected, priorityField.id],
                        listTagItemSelected: newListTagItemSelected
                    });
                    newMessage = handleWhenRenderTagFieldPriority(
                        priorityField,
                        fieldItemsResult.items,
                        false,
                        newListTagItemSelected
                    );
                    newMessagesList.push(newMessage);
                    break;
                }
                case Constant.CHATBOT_NEXT_STEP.SHOW_FIELD_LIST:
                    newMessage = buildListTagFieldMessage(
                        nextStep.fields,
                        listTagFieldSelected,
                        1,
                        false,
                        usingAI,
                        listTagFieldSelected,
                        newListTagItemSelected
                    );
                    newMessagesList.push(newMessage);
                    break;
                default:
                    break;
            }

            // Replace loading with real response
            setMessages(prev => {
                const withoutLoading = prev.filter(m => m.idMessage !== loadingMsg.idMessage);
                return [...withoutLoading, newMessage];
            });

            // Persist only real messages
            createMessageList(
                newMessagesList,
                supportThreadIdState,
                affiliationOrganization,
                isModePreview,
                selectedOfOption,
                affiliationProject,
                projectInuseDetail,
                currentCorporationDetail,
                categoryIdSelected
            );
        } catch (error) {
            setMessages(prev => prev.filter(m => m.idMessage !== loadingMsg.idMessage));
            handlerWhenSelectedFormNoFound(messages, newMessagesList);
        } finally {
            setIsLoadingStep(false);
        }
    };
    const getLogoHeader = async keyLogo => {
        if (Utils.isEmptyObject(keyLogo)) return;

        if (keyLogo === Constant.CHATBOT_DEFAULT || keyLogo === Constant.SETTING_CHAT_BOT.SEND_LOGO) {
            return keyLogo;
        }

        let keyFile = `/public/${keyLogo}`;

        let logo = Utils.getCloudFrontUrlOfFilePublicAll(keyFile);
        if (logo) return logo;

        logo = await Storage.get(keyLogo, { level: 'public' });
        return logo;
    };

    const onChangeOptionsAutocomplete = (_, value) => {
        if (!value.id) {
            return false;
        }
        let lastMessage = messages[messages.length - 1];
        switch (lastMessage.messageType) {
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM:
                handleClickFormOption(value, lastMessage?.idMessage);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_FIELD:
                handleClickFieldOption(value, lastMessage?.idMessage);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_ITEM:
                handleClickItemOption(value, lastMessage?.idMessage);
                break;
            default:
                break;
        }
        setSelectedOptions({});
    };

    const onSubmitSendMessage = async (value) => {
        if (Utils.isEmptyString(value) && !isEnableBtnSend) { return false }
        
        let newMessagesList = [];
        let newIdMessage = getCurrentTimeForMessage();
        let messageClone = cloneDeep([...messages]);

        if (isModePreview) {
            newMessagesList = [
                {
                    content: value,
                    isFromMe: true,
                    idMessage: newIdMessage,
                    noInFrame: 0,
                    messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.USER_SEND_CHAT_AI
                },
                {
                    isFromMe: false,
                    isLoadingMessage: false,
                    idMessage: newIdMessage,
                    content: getMessage('bot_ai_preview_response'),
                }
            ];
            setMessages([...messageClone, ...newMessagesList]);
            return false;
        }

        newMessagesList = [
            {
                content: value,
                isFromMe: true,
                idMessage: newIdMessage,
                noInFrame: 0,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.USER_SEND_CHAT_AI
            },
            {
                isFromMe: false,
                isLoadingMessage: true,
                idMessage: newIdMessage,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE
            }
        ];
        
        let chatPostId = uuidv4();

        setMessages([...messageClone, ...newMessagesList]);
        setIdOfResponseMessage(chatPostId);
        scrollIntoViewMsg();
        setIsEnableBtnSend(false);
        let paramsKnowledgeBase = {
            view: queryGetListKnowledgeBase?.view,
            tagFieldQuery: queryGetListKnowledgeBase?.tagFieldSelected
        }

        const categoryDetail = listCategories.find(category => {
            return category.id === categoryIdSelected;
        });

        const viewStructure = categoryDetail.viewStructure;

        try {
            let requestDto = {
                corporationId: currentCorporationDetail.id,
                projectId: projectInuseDetail.id,
                currentUserId: 'anonymous',
                chatThreadId: supportThreadIdState,
                message: value,
                queryGetListKnowledgeBase: JSON.stringify(paramsKnowledgeBase),
                projectInuseType: 'PRJ_GENERAL',
                ticketIdList: [],
                ticketProperty: 'SENT',
                from: 0,
                size: 30,
                chatPostId: chatPostId,
                formQASystem: JSON.stringify(formQASystem),
                categoryIdSelected: categoryIdSelected,
                structure: JSON.stringify(viewStructure),
                // TZL-001: visitor timezone, so the AI knowledge base matches the chatbot drilldown counts
                timeZone: getPublicPageTimezone()
            }
            const basicPromptInSettingChatbot = chatbotSettings?.basicPrompt ? chatbotSettings?.basicPrompt : ""
            const basicPromptID = Utils.destructLinkPrompt(basicPromptInSettingChatbot)
            const lastSelectedTag = listSelectedItemOfSession[listSelectedItemOfSession.length - 1];
            const selectedTagGroupId = lastSelectedTag ? Object.keys(lastSelectedTag)[0] : '';
            const tagGroupKeyValue = selectedTagGroupId ? { [selectedTagGroupId]: selectedTagGroupId } : {};
            const dataLog = {
                corporationDetail: {}, // pks this's not existed
                projectDetail: {},
                userDetail: {},
                rootProjectDetail: projectInuseDetail,
                rootCorporationDetailId: currentCorporationDetail?.id,
                tabNameChatAI: '',
                aiChatInquiryText: value,
                basicPromptID: basicPromptID,
                userSelectedPrompt: [],
                projectIdKnowledgeSelected: '',
                hitNumber: numberHitKnowledgeTicket,
                qaCategoryId: categoryIdSelected,
                tagFieldsSelected: [tagGroupKeyValue, ...listSelectedItemOfSession] // first item is always lasted tag group, another items is tag items.
            }

            const logKibanaData = createKibanaInteractChatAI(dataLog, LogKibanaConstant.AI_CHAT_SCREEN.ROBO);
            requestDto = {
                ...requestDto,
                logKibanaData: JSON.stringify(logKibanaData)
            };

            await sendAiChatBotApi(requestDto,setMessages,getCurrentTimeForMessage);

        } catch (error) {
            console.error("Component ChatBox ~ sendAiChatBotApi", error);

            if (Array.isArray(messages) && messages.length > 0) {
                let errorMessage = {
                    isFromMe: false,
                    content: trI18n('MSG-PROCESSING-TIME-EXCEEDED'),
                    isError: true
                };
                setMessages([...messages, errorMessage]);
            }
        }
    }

    const handleWhenRenderTagFieldPriority = (
        fieldDetail,
        items,
        isDisplayBackBtnInItemMessage = false,
        listTagItemSelectedNow
    ) => {
        let newMessage = buildListItemMessage(
            fieldDetail.id,
            items,
            1,
            fieldDetail.label,
            isDisplayBackBtnInItemMessage,
            usingAI,
            listTagFieldSelected,
            listTagItemSelectedNow
        );

        return newMessage;
    };

    function hasScrollbar() {
        return document.documentElement.scrollHeight > document.documentElement.clientHeight;
    }

    const callUpdatedEndChat = async () => {
        setIsShowModalEndChat(false);
        setIsShowMsgConnecting(false);

        setIsActivateLiveChat(false);
        const backToBeginMessage = buildTheEndMessage(1, formQASystem, resolvedMessages);
        setMessages(pev => [...pev, backToBeginMessage]);
        postMessage(backToBeginMessage, supportThreadIdState, affiliationOrganization);

        //Call API update after user end chat
        await anounymousEndLiveChat(supportTicketId);
    };

    const isShowChatBot = () => {
        if (isModePreview) {
            return (corporationDetail?.limitValue?.knowledgeBot === 1);
        }
        return (currentCorporationDetail?.isKnowledgeBotOn === 1);
    }
    const usingAI = props?.publicKnowledgeSetting?.usingAI || props?.usingAI;

    if (!isLoadingCss && !isModePreview) {
        return ( <LoadingPanel isLoading={true} />)
    }

    const renderIdNameByScreenAndDevice = ()=>{
        let idName = "parentCo"
        if(isIframeChatBot){ // in iframe desktop screen, don't need parentCo
            if(Number(deviceWidth) > POPUlAR_MOBILE_DEVICE_WIDTH) {
                idName = ""
            }
        }
        return idName
    }

    if(isIframeChatBot && !isPublicAccess) {
        return (
            <Fragment>
                {isShowChatBot() && <>
                    {!isShowChatBox && !isModePreview && (
                        <CollapseChatBox
                            setIsShowChatBox={() => {
                                setIsShowChatBox(true);
                                setIsNewUnReaMessage(false);
                            }}
                            chatbotSettings={chatbotSettings}
                            isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                            isNewUnReadMessage={isNewUnReadMessage}
                            POPUlAR_MOBILE_DEVICE_WIDTH={POPUlAR_MOBILE_DEVICE_WIDTH}
                            deviceWidth={deviceWidth}
                        />
                    )}
                    <div
                        className={`chat-box ${!isShowChatBox && !isModePreview && 'displayNone'} ${
                            isModePreview
                                ? 'chat-window-root chat-window-preview'
                                : isMaximizedPanel
                                ? 'chat-window-root chat-window-maximized'
                                : 'chat-window-root chat-window-minimized'
                        } ${hasScrollbar() && isShowModalReload && 'chat-window-root chat-box-position'} `}
                        id={renderIdNameByScreenAndDevice()}
                    >
                        <ExpandHeaderChatbox
                            isModePreview={isModePreview}
                            chatbotSettings={chatbotSettings}
                            setIsShowChatBox={setIsShowChatBox}
                            isMaximizedPanel={isMaximizedPanel}
                            setIsMaximizedPanel={setIsMaximizedPanel}
                            isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                            setIsShowModalEndChat={setIsShowModalEndChat}
                            isActivateLiveChat={isActivateLiveChat}
                            setIsNewUnReaMessage={setIsNewUnReaMessage}
                            getMessage={getMessage}
                        />

                        <div class='ip-restriction-message'>
                            <IPRestrictionMessage />
                        </div>
                    </div>
                 </>}
            </Fragment>
        )
    }

    return (
        <Fragment>
            {isShowChatBot() && <>
                {!isShowChatBox && !isModePreview && (
                    <CollapseChatBox
                        setIsShowChatBox={() => {
                            setIsShowChatBox(true);
                            setIsNewUnReaMessage(false);
                        }}
                        chatbotSettings={chatbotSettings}
                        isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                        isNewUnReadMessage={isNewUnReadMessage}
                        POPUlAR_MOBILE_DEVICE_WIDTH={POPUlAR_MOBILE_DEVICE_WIDTH}
                        deviceWidth={deviceWidth}
                    />
                )}
                <div
                    className={`chat-box ${!isShowChatBox && !isModePreview && 'displayNone'} ${
                        isModePreview
                            ? 'chat-window-root chat-window-preview'
                            : isMaximizedPanel
                            ? 'chat-window-root chat-window-maximized'
                            : 'chat-window-root chat-window-minimized'
                    } ${hasScrollbar() && isShowModalReload && 'chat-window-root chat-box-position'} `}
                    id={renderIdNameByScreenAndDevice()}
                >
                    <ExpandHeaderChatbox
                        isModePreview={isModePreview}
                        chatbotSettings={chatbotSettings}
                        setIsShowChatBox={setIsShowChatBox}
                        isMaximizedPanel={isMaximizedPanel}
                        setIsMaximizedPanel={setIsMaximizedPanel}
                        isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                        setIsShowModalEndChat={setIsShowModalEndChat}
                        isActivateLiveChat={isActivateLiveChat}
                        setIsNewUnReaMessage={setIsNewUnReaMessage}
                        getMessage={getMessage}
                    />
    
                    <ChatBotListMessage
                        messages={messages}
                        chatbotSettings={chatbotSettings}
                        handleClickFormOption={handleClickFormOption}
                        handleClickFieldOption={handleClickFieldOption}
                        listCategories={listCategories}
                        setMessages={setMessages}
                        listTagFieldSelected={listTagFieldSelected}
                        handleClickItemOption={handleClickItemOption}
                        supportThreadIdState={supportThreadIdState}
                        affiliationOrganization={affiliationOrganization}
                        filterPublicKnowledge={filterPublicKnowledge}
                        listSelectedItemOfSession={listSelectedItemOfSession}
                        listTicketIdBeforeFilterTagField={listTicketIdBeforeFilterTagField}
                        setListKnowledgeTicketId={setListKnowledgeTicketId}
                        projectId={affiliationProject}
                        subDomain={props?.subDomain}
                        scrollIntoViewMsg={scrollIntoViewMsg}
                        messageRef={messageRef}
                        isModePreview={isModePreview}
                        setListTagFieldOfSelectedCategory={setListTagFieldOfSelectedCategory}
                        setListTagFieldId={setListTagFieldId}
                        setFilterPublicKnowledge={setFilterPublicKnowledge}
                        setListSelectedItemOfSession={setListSelectedItemOfSession}
                        setListTagFieldSelected={setListTagFieldSelected}
                        handleWhenRenderTagFieldPriority={handleWhenRenderTagFieldPriority}
                        setListTicketIdBeforeFilterTagField={setListTicketIdBeforeFilterTagField}
                        listKnowledgeTicketId={listKnowledgeTicketId}
                        listTagFieldOfSelectedCategory={listTagFieldOfSelectedCategory}
                        projectAlias={projectAlias}
                        API={props?.API}
                        categoryIdSelected={categoryIdSelected}
                        formQASystem={formQASystem}
                        isMaximizedPanel={isMaximizedPanel}
                        setIsShowModalReload={setIsShowModalReload}
                        setIsActivateLiveChat={setIsActivateLiveChat}
                        setSupportTicketId={setSupportTicketId}
                        setFileUploadList={setFileUploadList}
                        fileUploadList={fileUploadList}
                        fileUploading={fileUploading}
                        isShowMsgConnecting={isShowMsgConnecting}
                        sentMessageList={sentMessageList}
                        listAgentData={listAgentData}
                        isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                        projectInuseDetail={projectInuseDetail}
                        currentCorporationDetail={currentCorporationDetail}
                        idOfResponseMessage={idOfResponseMessage}
                        setIsEnableBtnSend={setIsEnableBtnSend}
                        isEnableBtnSend={isEnableBtnSend}
                        setQueryGetListKnowledgeBase={setQueryGetListKnowledgeBase}
                        usingAI={usingAI}
                        listTagItemSelected={listTagItemSelected}
                        setIsEnableMsgInput={setIsEnableMsgInput}
                        listTagFieldSkip={listTagFieldSkip}
                        setListTagFieldSkip={setListTagFieldSkip}
                        enableListTicket={enableListTicket}
                        getMessage={getMessage}
                        resolvedMessages={resolvedMessages}
                        isLoadingStep={isLoadingStep}
                    />
    
                    {/* message connecting  */}
                    <MessageConnecting
                        chatbotSettings={chatbotSettings}
                        supportThreadIdState={supportThreadIdState}
                        affiliationOrganization={affiliationOrganization}
                        messages={messages}
                        setMessages={setMessages}
                        isModePreview={isModePreview}
                        isMaximizedPanel={isMaximizedPanel}
                        getMessage={getMessage}
                    />
    
                    {/* chatbot input  */}
                    {isActivateLiveChat && !isModePreview ? (
                        <ChatBotLiveChat
                            chatbotSettings={chatbotSettings}
                            listOptionsAutocomplete={listOptionsAutocomplete}
                            onChangeOptionsAutocomplete={onChangeOptionsAutocomplete}
                            selectedOfOptions={selectedOfOptions}
                            setMessages={setMessages}
                            isActivateLiveChat={isActivateLiveChat}
                            supportTicketId={supportTicketId}
                            supportThreadId={supportThreadIdState}
                            affiliationOrganization={affiliationOrganization}
                            setFileUploadList={setFileUploadList}
                            setFileUploading={setFileUploading}
                            setSentMessageList={setSentMessageList}
                            isModePreview={isModePreview}
                            API={API}
                            getMessage={getMessage}
                        />
                    ) : (
                        <ChatBotInput
                            isModePreview={isModePreview}
                            listOptionsAutocomplete={listOptionsAutocomplete}
                            onChangeOptionsAutocomplete={onChangeOptionsAutocomplete}
                            setMessages={setMessages}
                            onSubmitSendMessage={onSubmitSendMessage}
                            usingAI={usingAI}
                            isEnableBtnSend={isEnableBtnSend}
                            messages={messages}
                            chatbotSettings={chatbotSettings}
                            setIsEnableMsgInput={setIsEnableMsgInput}
                            isEnableMsgInput={isEnableMsgInput}
                            listTagFieldOfSelectedCategory={listTagFieldOfSelectedCategory}
                            setListTagFieldOfSelectedCategory={setListTagFieldOfSelectedCategory}
                            getMessage={getMessage}
                        />
                    )}
    
                    <ConfirmDialog
                        isOpen={isShowModalReload && !isModePreview}
                        msgConfirm={trI18n('COMMSG030')}
                        okCallBack={() => window.location.reload()}
                    />
    
                    <ConfirmDialog
                        isOpen={isShowModalEndChat}
                        msgConfirm={trI18n('CBOTMSG017')}
                        okCallBack={callUpdatedEndChat}
                        closeCallBack={() => setIsShowModalEndChat(false)}
                        textSubmit={trI18n('COMBTN002')}
                        textClose={trI18n('COMBTN007')}
                    />
                </div>
            </>}
        </Fragment>
    );
}

export default ChatBox;
